<besafe-header [isBackground]="true"></besafe-header>

<div class="d-flex justify-content-center m-3 voucher-dialog">
  <div class="card">

    <ng-container *ngIf="!isActivated">
      <h1
        class="popup-title inverted text-center mt-0"
        i18n="Connect your voucher@@connect-voucher-header">Connect your voucher</h1>
      
      <p class="text-center inverted mb-4"
        i18n="Voucher message@@voucher-message">Please enter your cell phone number and the voucher will be conected to it. Then you should install bSafe app and use the same cell number when you create account. The voucher will be applied automatically and you will be upgraded to Premium subscription. If you already have bsafe account, the voucher will be applied when you open the app.</p>
      
        <form
          [formGroup]="voucherActivationForm"
          novalidate>
      
          <!-- <div class="form-group mb-4">
            <besafe-input
              class="inverted"
              [type]="'tel'"
              formControlName="phoneNumber"
              i18n-placeholder="Phone Number placeholder@@phoneNumber-placeholder"
              placeholder="Phone Number">
            </besafe-input>
      
            <besafe-form-message
              type="error"
              [show]="voucherActivationForm.controls['phoneNumber'].touched">
              <span *ngIf="voucherActivationForm.controls['phoneNumber'].hasError('required')"
                i18n="Field is required@@field-is-required">Field is required</span>
            </besafe-form-message>
          </div> -->
          <div class="form-row mb-4">
            <div class="col-4">
              <besafe-select
                [options]="codesOptions"
                placeholder="Code"
                i18n-placeholder="Phone code placeholder@@phone-code-placeholder"
                formControlName="code">
              </besafe-select>
      
              <besafe-form-message
                type="error"
                [show]="voucherActivationForm.controls['code'].touched">
                <span
                  *ngIf="voucherActivationForm.controls['code'].hasError('required')"
                  i18n="Field is required@@field-is-required">Field is required</span>
              </besafe-form-message>
            </div>

            <div class="col-8">
              <besafe-input
                class="inverted"
                type="tel"
                formControlName="phone"
                placeholder="Phone number"
                i18n-placeholder="Phone number placeholder@@phone-number-placeholder">
              </besafe-input>
      
              <besafe-form-message
                type="error"
                [show]="voucherActivationForm.controls['phone'].touched">
                <span *ngIf="voucherActivationForm.controls['phone'].hasError('required')"
                  i18n="Field is required@@field-is-required">Field is required</span>
              </besafe-form-message>
            </div>
          </div>

          <div class="form-group mb-4">
            <besafe-input
              class="inverted"
              type="text"
              placeholder="Voucher Code"
              i18n-placeholder="Voucher Code input placeholder@@voucher-input-placeholder"
              formControlName="couponCode">
            </besafe-input>
        
            <besafe-form-message
              type="error"
              [show]="voucherActivationForm.controls['couponCode'].touched">
              <span
                *ngIf="voucherActivationForm.controls['couponCode'].hasError('required')"
                i18n="Field is required@@field-is-required">Field is required</span>
            </besafe-form-message>

            <besafe-form-message
              type="error"
              [show]="errorMessage">
              <span>{{errorMessage}}</span>
            </besafe-form-message>
          </div>
      
          <besafe-button
            i18n="Button Apply@@button-apply"
            (click)="applyCode(voucherActivationForm.value)"
            [btnDisabled]="!voucherActivationForm.valid">Apply</besafe-button>
        </form>
      </ng-container>


      <ng-container *ngIf="isActivated">
        <h1
          class="popup-title inverted text-center"
          i18n="Voucher connected@@voucher-connected-header">Voucher connected</h1>
      
        <div class="text-center m-4">
          <img src="../../../../assets/icons/icon_done.svg" alt="Done">
        </div>
      
        <p
          *ngIf="userExist"
          class="text-center inverted"
          i18n="Voucher connected for registered@@voucher-connected-registered">Voucher is successfuly connected to your phone number. One year of access to bSafe premium functionality will be added to your account when you will open bsafe app.</p>

        <ng-container *ngIf="!userExist">
          <p
            class="text-center inverted"
            i18n="Voucher connected for unregistered@@voucher-connected-unregistered">Voucher is successfuly connected to your phone number. You can now start using premium features of bSafe aapp. Just download the app on your phone and create account using your phone number.</p>
          <div class="d-flex justify-content-around mb-4">
            <a href="https://itunes.apple.com/app/bsafe-personal-safety-app/id459709106" class="btn btn-store mr-1" *ngIf="(initService.isMobile() && initService.isIOs()) || !initService.isMobile()">
              <img src="../../../assets/img/button-appstore.png" alt="Appstore" class="img-fluid">
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.bipper.app.bsafe" class="btn btn-store" *ngIf="(initService.isMobile() && initService.isAndroid()) || !initService.isMobile()">
              <img src="../../../assets/img/button-googleplay.png" alt="Googleplay" class="img-fluid">
            </a>
          </div>
        </ng-container>
  
      </ng-container>
  </div>
  </div>